module.exports = function getResource(label, vars = []) {
    const resources = { chooseLocation: 'Choose a location' };
    return resources[label];
};
